import { api } from "@/api";
import { CorrectionPreviewDto } from "./correctionPreview";

// Same gates as the finalize; nothing is persisted.
export const previewManualFinalizeMatch = async (
  matchId: string
): Promise<CorrectionPreviewDto> => {
  const res = await api.client.post(
    `/matches/${matchId}/manual-finalize/preview`
  );
  return res.data;
};
